var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomebtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_246)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5625 29.0625H23.9766L31.9688 21.0703C32.6953 20.3438 32.6953 19.1328 31.9688 18.4062C31.2422 17.6797 30.0312 17.6797 29.3047 18.4062L18.4062 29.3047C17.9219 29.7891 17.9219 30.5156 17.9219 31C17.9219 31.4844 17.9219 32.2109 18.4062 32.6953L29.3047 43.5938C30.0312 44.3203 31.2422 44.3203 31.9688 43.5938C32.6953 42.8672 32.6953 41.6562 31.9688 40.9297L23.9766 32.9375H44.5625C45.5312 32.9375 46.5 31.9688 46.5 31C46.5 30.0312 45.5312 29.0625 44.5625 29.0625ZM31 0C13.8047 0 0 13.8047 0 31C0 48.1953 13.8047 62 31 62C48.1953 62 62 48.1953 62 31C62 13.8047 48.1953 0 31 0ZM31 58.125C15.9844 58.125 3.875 46.0156 3.875 31C3.875 15.9844 15.9844 3.875 31 3.875C46.0156 3.875 58.125 15.9844 58.125 31C58.125 46.0156 46.0156 58.125 31 58.125Z",
    fill: "#FF7919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomebtn);
export default __webpack_public_path__ + "static/media/homebtn.96cfe12403cd106a2ec4e020500f43eb.svg";
export { ForwardRef as ReactComponent };